<template>
    <section>
        <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>


        <b-field horizontal label="Название">
            <b-input expanded v-model="title"></b-input>
        </b-field>

        <b-field horizontal label="Описание">
            <b-input type="textarea" expanded v-model="description"></b-input>
        </b-field>

        <b-field horizontal label="Активность">
            <b-checkbox expanded v-model="isActive"></b-checkbox>
        </b-field>

        <b-field horizontal label="Действие">
            <promo-action-select :action.sync="action"/>
        </b-field>

        <b-field v-if="action === 1" horizontal label="Блюдо">
            <dish-select :dish.sync="dish"/>
        </b-field>

        <b-field v-if="action === 2" horizontal label="Комбо">
            <combo-select :combo.sync="combo"/>
        </b-field>

        <b-field v-if="action === 3" horizontal label="Ссылка">
            <b-field horizontal label="В новой вкладке">
                <b-checkbox v-model="blank"></b-checkbox>
            </b-field>
            <br/>
            <b-field horizontal label="Ссылка">
                <b-input v-model="url" placeholder="Ссылка"></b-input>
            </b-field>
        </b-field>

        <div class="block">
            <b-field horizontal label="Изображение">
                <b-upload v-model="image" drag-drop>
                    <section>
                        <div class="content has-text-centered">
                            <img style="width: 930px; height: 350px" :src="image ? uploadedImage:  image">
                        </div>
                    </section>
                </b-upload>
            </b-field>
        </div>

        <b-field horizontal>
            <p class="control">
                <b-button label="Создать" type="is-primary" @click="create()" :disabled="loading"/>
            </p>
        </b-field>
    </section>
</template>

<script>
import promoRepository from "../../repository/promoRepository";
import PromoActionSelect from "../../components/Common/PromoActionSelect";
import ComboSelect from "../../components/Common/ComboSelect";
import DishSelect from "../../components/Common/DishSelect";

export default {
    components: {DishSelect, ComboSelect, PromoActionSelect},
    computed: {
        uploadedImage() {
            if (!this.image)
                return;

            return URL.createObjectURL(this.image);
        },
        infoParam() {
            switch (this.action) {
                case 1:
                    return {
                        id: this.dish
                    };
                case 2:
                    return {
                        id: this.combo
                    };
                case 3:
                    return {
                        blank: this.blank,
                        url: this.url
                    }
                default:
                    return null;
            }
        }
    },
    data() {
        return {
            title: undefined,
            description: undefined,
            isActive: true,
            action: undefined,
            image: undefined,
            info: undefined,
            combo: undefined,
            dish: undefined,
            blank: undefined,
            url: undefined,
            loading: false
        }
    },
    methods: {
        create() {
            this.loading = true;

            promoRepository.create(this.title, this.description, this.image, this.action, JSON.stringify(this.infoParam), this.isActive)
                .then(() => this.$router.push({name: "Promo"}))
                .then(() => this.$buefy.toast.open('Акция создана'))
                .catch(() => this.$buefy.toast.open('Ошибка при создании акции'))
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style scoped>

</style>
